"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireDefault(require("../../Input"));

var _createStyled = require("../../../utils/createStyled");

var _list = _interopRequireDefault(require("../style/list"));

var _transformIconToComponent = _interopRequireDefault(require("../../../utils/transformIconToComponent"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var List = function List(props) {
  var _props$query = props.query,
      onChange = _props$query.onChange,
      value = _props$query.value,
      placeholder = _props$query.placeholder,
      qaNode = _props$query.qaNode,
      forwardedRef = _props$query.forwardedRef,
      onKeyDown = _props$query.onKeyDown,
      style = _props$query.style,
      icon = _props$query.icon,
      theme = _props$query.theme,
      _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hover = _useState2[0],
      hoverHandler = _useState2[1],
      _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      focus = _useState4[0],
      focusHandler = _useState4[1],
      styles = (0, _list["default"])(theme, null, {
    hover: hover,
    focus: focus
  }),
      searchIcon = (0, _transformIconToComponent["default"])(_objectSpread({
    source: icon
  }, styles.icon));

  var memoStyle = (0, _react.useMemo)(function () {
    return _objectSpread({}, styles.query, {}, style);
  }, [style]);
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.queryWrapper
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.iconWrapper
  }, searchIcon), _react["default"].createElement(_Input["default"], {
    onChange: onChange,
    onKeyDown: onKeyDown,
    value: value,
    placeholder: placeholder,
    "data-qa-node": qaNode,
    ref: forwardedRef,
    onMouseEnter: function onMouseEnter() {
      return hoverHandler(true);
    },
    onMouseLeave: function onMouseLeave() {
      return hoverHandler(false);
    },
    onFocus: function onFocus() {
      return focusHandler(true);
    },
    onBlur: function onBlur() {
      return focusHandler(false);
    },
    style: memoStyle
  })), props.render({
    list: props.list
  }));
};

List.propTypes = {
  theme: _propTypes["default"].object,
  list: _propTypes["default"].array,
  render: _propTypes["default"].func,
  style: _propTypes["default"].object,
  query: _propTypes["default"].shape({
    value: _propTypes["default"].string,
    placeholder: _propTypes["default"].string,
    qaNode: _propTypes["default"].string,
    forwardedRef: _propTypes["default"].object,
    onKeyDown: _propTypes["default"].func,
    style: _propTypes["default"].object
  })
};
var _default = List;
exports["default"] = _default;